// extracted by mini-css-extract-plugin
module.exports = {"default":"TextLink_default__xJ9ka","underlined":"TextLink_underlined__XlZto"};